var datatableInit = function () {
  const table = $("#datatable-list");
  if (table.length > 0 && !$.fn.DataTable.isDataTable(table)) {
    table.DataTable({
      stripeClasses: ["pure-table-odd", "pure-table-even"],
    });
  }
};
$(document).on("admin-users-index:ready", function () {
  const usersTable = $("#datatable-list");
  if (usersTable.length === 0) return; // Guard if table not present

  // If DataTables is already initialized, destroy it first
  if ($.fn.DataTable.isDataTable(usersTable)) {
    usersTable.DataTable().destroy();
  }

  usersTable.DataTable({
    processing: true, // Show processing indicator
    serverSide: true,
    ajax: {
      url: usersTable.data("source") || admin_users_path, // Get URL from data-source or default
      type: "GET", // Or POST, depending on your preference and if params get too long
      data: function (d) {
        // Function to extend data sent to server
        // Add custom filter `filter[q]` from our search box
        d.filter = { q: $("#search-users").val() };
        // Add role and type filters if they exist on the page
        // These are usually part of the form submitted, ensure they are included in AJAX
        // This might require hidden fields for role/type to be present and read here
        // or ensuring the controller correctly picks them up from dt_params or general params.
        // For now, assuming controller handles role/type from general params passed with AJAX call.
      },
    },
    columns: [
      { data: 0, name: "email", title: "Email" },
      { data: 1, name: "last_name", title: "Name" },
      { data: 2, name: "business.name", title: "Business" }, // name can reflect association for clarity
      { data: 3, name: "role", title: "Role" },
      { data: 5, name: "last_sign_in_at", title: "Last Signed In" },
      {
        data: 4, // Corrected: user.id is now at index 4 in the server data array
        name: "actions",
        title: "Actions", // Changed from "Edit"
        orderable: false,
        searchable: false,
        render: function (data, type, row) {
          // data is user.id, row[6] is current_user.system_admin?
          const userId = data;
          const isSystemAdmin = row[6];
          
          let actionsHtml = `<a href="/admin/users/${userId}/edit" style="color: #666; text-decoration: none; display: inline-flex; align-items: center; gap: 4px; font-size: 0.9em;">
            <i class="fa fa-pencil" style="font-size: 0.9em;"></i>
            <span>edit</span>
          </a>`;
          
          // Add impersonate button for system admins
          if (isSystemAdmin) {
            actionsHtml += ` | <form method="post" action="/admin/users/${userId}/impersonate" style="display: inline;">
              <input type="hidden" name="authenticity_token" value="${document.querySelector('meta[name="csrf-token"]').getAttribute('content')}">
              <button type="submit" style="background: none; border: none; color: #007bff; text-decoration: underline; cursor: pointer; font-size: 0.9em; padding: 0;">
                <i class="fa fa-user-secret" style="font-size: 0.9em; margin-right: 4px;"></i>impersonate
              </button>
            </form>`;
          }
          
          return actionsHtml;
        },
      },
    ],
    order: [[0, "asc"]], // Default sort by email ascending
    stripeClasses: ["pure-table-odd", "pure-table-even"],
    pageLength: 10, // Default page length
    dom: "lrtip", // Remove DataTables default search, 'l' for length, 'r' for processing, 't' for table, 'i' for info, 'p' for pagination
    language: {
      processing: '<div class="dt-processing">Loading...</div>',
      search: "_INPUT_", // Allows placeholder via CSS if needed
      searchPlaceholder: "Search table...", // If using DT search box
    },
  });

  // Custom search input handling
  const searchInput = $("#search-users");
  const triggerSearch = () => {
    usersTable.DataTable().search(searchInput.val()).draw();
  };

  searchInput.on("keypress", function (e) {
    if (e.which === 13) {
      // Enter key pressed
      e.preventDefault(); // Prevent default form submission if it's in a form
      triggerSearch();
    }
  });

  // Optional: if your clickable headers are still intended to work AND DataTables should handle sort requests:
  // Remove our custom sort submission from admin_sorting.js for this page,
  // or make DataTables column non-orderable for headers handled by admin_sorting.js if we want to keep custom param names.
  // For server-side DataTables, it's generally best to let DataTables manage the `order` param.
  // Our controller's `process_users_for_datatables` already uses `params[:order]`.
  // So, ensure `admin_sorting.js` does NOT submit the form for users page, instead let DT handle sort clicks.
  // The `columnDefs` in the previous attempt to make columns not `orderable` by DT should be reviewed.
  // With serverSide=true, DT will send order[i][column] and order[i][dir].
});
$(document).on("admin-experiences-index:ready", function () {
  const table = $("#datatable-list");
  if (table.length > 0 && !$.fn.DataTable.isDataTable(table)) {
    table.DataTable({
      order: [[1, "desc"]],
      stripeClasses: ["pure-table-odd", "pure-table-even"],
    });
  }
});
$(document).on("admin-contacts-index:ready", function () {
  datatableInit();
});
$(document).on("admin-tribes-index:ready", function () {
  const tribesTable = $("#datatable-list");
  if (tribesTable.length === 0) return;

  // If DataTables is already initialized from a previous state (e.g., client-side attempt),
  // destroy it to re-initialize cleanly if needed, or to just remove its controls.
  if ($.fn.DataTable.isDataTable(tribesTable)) {
    tribesTable.DataTable().destroy();
  }

  // Initialize DataTables for the Tribes table with NO controls, only the table itself.
  // This is because we are handling pagination, search, sort, and length via Rails and custom JS.
  // We mainly use DataTables here for its table structure and potential styling benefits if any are applied globally.
  tribesTable.DataTable({
    stripeClasses: ["pure-table-odd", "pure-table-even"],
    searching: false, // Disable DataTables native search
    lengthChange: false, // Disable DataTables native show X entries
    paging: false, // Disable DataTables native pagination
    info: false, // Disable DataTables native "Showing X to Y of Z entries"
    ordering: false, // Disable DataTables native column sorting, we use admin_sorting.js
    autoWidth: false, // Optional: can help with layout consistency
    // Alternatively, a very minimal dom: 't' could be used if we want zero DT features other than attaching to the table.
    // However, explicitly setting features to false is clearer for this non-server-side DT scenario.
  });
});

$(document).on("admin-dashboards-index:ready", function () {
  datatableInit();
});
